import M from 'backbone.marionette'
import T from './adminpunchlist.html'
import T2 from './adminpunchlistitem.html'
import Backbone from 'backbone'
import TContainer from './adminpunchlistcontainer.html'
import { showModal } from '../../utils/bootstrap/modal'
import { EditPunch } from './edit'
import moment from 'moment'
import { FormHandler } from '../../utils/bootstrap/form/formhandler'
import Radio from 'backbone.radio';

export const AdminPunchList = M.View.extend({
    template: _.template(T),
    filter: null,
    groups: null,
    regions: {
        'table': {
            el: '.punchlist',
            replaceElement: false
        }
    },
    events: {
        'click .organisePunch': 'onOrganisePunchClick',
        'click .filterPunch':'onFilterPunchClick',
    },
    modelEvents: {
        'change:organisePunch':'onFilterGroupChanged',
        'change:filterPunch':'onFilterGroupChanged',
        'change:punchreport_id':'onFilterGroupChanged',
    },
    initialize: function(){
        this.setUpCollection();
    },
    setUpCollection: function(){
        console.log('setUpCollection')
        const col = this.getOption('punches').filter(p => p.get('punchreport_id') == this.model.get('punchreport_id'))
        if(this.model.get('filterPunch') == 1){
            this.collection = new Backbone.Collection(col);
        }else{
            this.collection = new Backbone.Collection(col.filter(p => !p.get('validateContributeur_id')));
        }
        switch(this.model.get('organisePunch')){
            case 2:
                this.groups = this.model.get('etudiant');
                this.rowFilter = 'etudiant_id';
                this.headingTemplate = '<%=Prenom%> <%=NomFamille%>';
                break;
            case 3:
                this.groups = this.model.get('enseignant');
                this.rowFilter = 'enseignant_id';
                this.headingTemplate = '<%=Prenom%> <%=NomEnseignant%>';
                break;
            case 4:
                this.groups = this.model.get('competence');
                this.rowFilter = 'competence_id';
                this.headingTemplate = '<%=CodeCompetence%> <%=NomCompetence%>';
                break;
            default:
                this.groups = null;
                break;
        }
    },
    onFilterGroupChanged: function(){
        this.setUpCollection();
        this.render();
    },
    onOrganisePunchClick: function(event){
        const val = parseInt($(event.target).attr('data-value'));
        if(val && val != this.model.get('organisePunch')){
            this.model.set('organisePunch', val);
        }
    },
    onFilterPunchClick: function(event){
        const val = parseInt($(event.target).attr('data-value'));
        if(val && val != this.model.get('filterPunch')){
            this.model.set('filterPunch', val);
        }
    },  
    onRender: function(){
        console.log('this.groups', this.groups);
        if(this.groups){
            this.showChildView('table', new GroupList({
                collection: this.groups,
                punches: this.collection,
                childViewOptions: {
                    punches: this.collection,
                    mainModel: this.model,
                    rowFilter: this.rowFilter,
                    headingTemplate: this.headingTemplate,
                },
                childView: GroupedPunchGroup,
            }))
        }else{
            this.showChildView('table', new PunchList({
                collection: this.collection,
                childViewOptions: {
                    mainModel: this.model,
                    rowFilter: null,
                },
                childView: AdminPunchListItem,
                rowFilter: null,
            }))
        }
    }
})

const GroupList = M.CollectionView.extend({
    template: _.template(''),
    initialize: function(){
        console.log('GroupList', this.collection)
    },
     
})

const GroupedPunchGroup = M.View.extend({
    tagName: 'div',
    getTemplate: function(){
        return _.template('<div><h4>' + this.getOption('headingTemplate') + '</h4><div class="subList"></div></div>');
        //console.log('model', this.model)
        //return _.template('<div><h4>dosent work</h4><div class="subList"></div></div>');
    },
    serializeData: function(){
        return _.extend(this.model.toJSON(), {rowFilter: this.getOption('rowFilter')});
    },
    initialize: function(){
        console.log('viwe model', this.model.toJSON());
    },
    regions: {
        'subList':'.subList'
    },
    onRender: function(){

        const liste = new Backbone.Collection(this.getOption('punches').filter(p => p.get(this.getOption('rowFilter')) == this.model.get('id')));
        if(liste.length){
            this.showChildView('subList', new PunchList({
                collection: liste,
                rowFilter: this.getOption('rowFilter'),
                childViewOptions: {
                    mainModel: this.getOption('mainModel'),
                    rowFilter: this.getOption('rowFilter')
                },
                childView: AdminPunchListItem,
            }))
            this.$el.show();
        }else{
            this.$el.hide();

        }
        
    },
})


const PunchList = M.CollectionView.extend({
    template: _.template(TContainer),
    serializeData: function(){
        return {rowFilter: this.getOption('rowFilter')};
    },
    childViewContainer: '.list-group',
})

const AdminPunchListItem = M.View.extend({
    tagName: 'a',
    attributes: {
        'href':'#'
    },
    events: {
        'click':'onClick',
        'click .btValider':'onValiderClick'
    },
    className: 'list-group-item',
    template: _.template(T2),
    serializeData: function(){
        return _.extend(
            this.model.toJSON(),
            {
                etudiant: this.getOption('mainModel').get('etudiant').get(this.model.get('etudiant_id'))?.toJSON(),
                enseignant: this.getOption('mainModel').get('enseignant').get(this.model.get('enseignant_id'))?.toJSON(),
                competence: this.getOption('mainModel').get('competence').get(this.model.get('competence_id'))?.toJSON(),
                rowFilter: this.getOption('rowFilter')
            }
        )
    },
    onRender: function(){
        if(this.model.get('validateContributeur_id')){
            this.$el.addClass('list-group-item-success');
        }else{
            this.$el.removeClass('list-group-item-success');
        }
            
    },
    onClick: function(event){
        event.preventDefault();
        showModal('Modifier punch', new EditPunch({
            model: this.model,
            mainModel: this.getOption('mainModel'),
            user: this.getOption('mainModel').get('user'),
            enseignant: this.getOption('mainModel').get('enseignant').get(this.model.get('enseignant_id')),
        }))
    },
    onValiderClick: function(event){
        event.preventDefault();
        event.stopPropagation();
        const formHandler = new FormHandler();
        formHandler.addModel('punches', this.model);
        formHandler.save('api/specialiste/validerpunch/',
            this.onPunchValidated.bind(this),
            this.onPunchValidateError.bind(this)
        )
        return null;
    },
    onPunchValidated: function(response){
       console.log('response', response)
       Radio.channel('punch').trigger('save', response);
    },
    onPunchValidateError: function(errors){
        Toast.add('Une erreur a eu lieu :(', 'danger')
    }
});